import { render, staticRenderFns } from "./StaffDepartment.vue?vue&type=template&id=cbb9a886"
import script from "./StaffDepartment.vue?vue&type=script&lang=js"
export * from "./StaffDepartment.vue?vue&type=script&lang=js"
import style0 from "./StaffDepartment.vue?vue&type=style&index=0&id=cbb9a886&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports